module.exports = __webpack_public_path__ + "img/tarjetas-bancard.55573de7.png";